//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeCustomers', {
//        templateUrl: 'views/components/views/timeCustomers/timeCustomers.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['timeCustomersService', function (timeCustomersService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.searchtext = '' }
//                ],
//                setting: {},
//                itemsListTimeCustomers: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await timeCustomersService.getSetting())[0];
//            }

//            async function loadTimeCustomers() {
//                vm.model.itemsListTimeCustomers = await timeCustomersService.listTimeCustomers({
//                    cust_name: 'ALL',
//                    project_keyno: '0',
//                    ok: '0'
//                });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadSetting();
//                loadTimeCustomers();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
